<app-form-min-annoce></app-form-min-annoce>
<div class="cardList" fxlayoutgap="5px grid">
<ng-template ngFor let-place [ngForOf]="lstPlaces" let-i="index" >
  <app-annonce [place]="place"  fxFlex="1 1 auto" ></app-annonce>
</ng-template>
</div>
